import Rails from '@rails/ujs'
import Trix from 'trix'

import 'trix/dist/trix.css';
require('./trix_extra');

Trix.config.attachments.preview.caption = {
  name: false,
  size: false
};

// Trix 2 sanitizes attachment content and drops every <iframe>. The embed
// button in trix_extra.js stores a YouTube player as attachment content, so
// without this the embed disappears on insert and on every later save. Let
// that one source back in and leave the rest of the filter untouched.
const YOUTUBE_EMBED_SRC = /^https:\/\/(www\.)?youtube(-nocookie)?\.com\/embed\//

function isYoutubeEmbed(element) {
  return element.tagName === "IFRAME" &&
    YOUTUBE_EMBED_SRC.test(element.getAttribute("src") || "");
}

const sanitizer = Trix.HTMLSanitizer.prototype;
const elementIsForbidden = sanitizer.elementIsForbidden;
const sanitizeElement = sanitizer.sanitizeElement;

sanitizer.elementIsForbidden = function(element) {
  return isYoutubeEmbed(element) ? false : elementIsForbidden.call(this, element);
};

sanitizer.sanitizeElement = function(element) {
  const keepAllowfullscreen = isYoutubeEmbed(element) && element.hasAttribute("allowfullscreen");
  const sanitized = sanitizeElement.call(this, element);

  if (keepAllowfullscreen) sanitized.setAttribute("allowfullscreen", "");

  return sanitized;
};

// DOMPurify runs after the walker above, so it needs the same allowance.
// Every iframe it sees has already passed isYoutubeEmbed.
Trix.config.dompurify.ADD_TAGS = ["iframe"];
Trix.config.dompurify.ADD_ATTR = Trix.config.dompurify.ADD_ATTR.concat("allowfullscreen");

// Listen for the Trix attachment event to trigger upload
addEventListener("trix-attachment-add", function(event) {
  var attachment = event.attachment;
  const formElement = event.target.closest("form");

  if (attachment.file) {
    formElement.querySelector("input[type='submit']").setAttribute("disabled", "disabled");
    return uploadAttachment(attachment, formElement);
  }
});

addEventListener("trix-initialize", function(event) {
  addCameraButton(event);
  addEmbedVideoButtonAndDialog(event, Trix);
});


function uploadAttachment(attachment, formElement) {
  const file = attachment.file;
  const formData = _createFormData(file);

  var xhr = new XMLHttpRequest;
  xhr.open("POST", "/attachments/create_with_attachable.json", true);
  xhr.setRequestHeader("X-CSRF-Token", Rails.csrfToken());

  xhr.upload.onprogress = function(event) {
    var progress = event.loaded / event.total * 100;
    attachment.setUploadProgress(progress);
  }

  xhr.onload = function() {
    if ([200, 201, 204].includes(xhr.status)) {
      var data = JSON.parse(xhr.responseText);
      formElement.querySelector("input[type='submit']").removeAttribute("disabled");

      return attachment.setAttributes({
        url: data.image_url,
        token: data.token
      })
    }
  }

  return xhr.send(formData);
}

function _createFormData(file){
  const form = new FormData;
  form.append("Content-Type", file.type);
  form.append("attachment[image]", file);

  return form;
}
